import { Box, Flex, useBreakpointValue } from "@chakra-ui/react";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { useLocation } from "react-router";
import { TermsOfUse } from "./components/TermsOfUse";
import { ButtonTabs } from "../../components/tabs/ButtonTabs";
import { useMobileBreakpoint } from "../../utils/useBreakpoints";
import { ContentPolicy } from "./components/ContentPolicy";
import { PublisherTerms } from "./components/PublisherTerms";
import { AiPolicy } from "./components/AiPolicy";
import React, { useEffect } from "react";
import { useSubHeaderScroll } from "../../hooks/useSubHeaderScroll";

export function LegalScreen() {
  const location = useLocation();
  const isMobile = useMobileBreakpoint();
  const shouldTake80Percent = useBreakpointValue({ base: false, md: true });
  const scrollableRef = React.useRef<HTMLDivElement>(null);
  const { stickyTop: subHeaderTop, stickyTransform, stickyTransition } =
    useSubHeaderScroll();

  useEffect(() => {
    scrollableRef.current?.scrollTo(0, 0);
  }, [location]);

  return (
    <Flex width="100%" alignItems="center" direction="column">
      <Flex
        flexDirection="column"
        width={shouldTake80Percent ? "80%" : "100%"}
        maxWidth="960px"
      >
        <Box
          width="100%"
          position="sticky"
          top={subHeaderTop}
          transform={stickyTransform}
          transition={stickyTransition}
          zIndex={1}
          backgroundColor="charcoal.charcoal"
        >
          <ButtonTabs
            paddingTop={isMobile ? "16px" : "40px"}
            paddingBottom={isMobile ? "16px" : "20px"}
            marginLeft={isMobile ? "24px" : undefined}
            tabs={[
              {
                name: "Privacy Policy",
                link: "/privacy-policy",
                isActive: location.pathname === "/privacy-policy",
              },
              {
                name: "Terms of Service",
                link: "/terms-of-use",
                isActive: location.pathname === "/terms-of-use",
              },
              {
                name: "Content Policy",
                link: "/content-policy",
                isActive: location.pathname === "/content-policy",
              },
              {
                name: "AI Policy",
                link: "/ai-policy",
                isActive: location.pathname === "/ai-policy",
              },
              {
                name: "Publisher Terms of Service",
                link: "/publisher-terms-of-service",
                isActive: location.pathname === "/publisher-terms-of-service",
              },
            ]}
          />
        </Box>
        <Flex
          direction="column"
          paddingX={isMobile ? "24px" : undefined}
          ref={scrollableRef}
          css={
            !isMobile && {
              "&::-webkit-scrollbar": {
                display: "none",
              },
              "-ms-overflow-style": "none",
              "scrollbar-width": "none",
            }
          }
        >
          {(() => {
            switch (location.pathname) {
              case "/privacy-policy":
                return <PrivacyPolicy />;
              case "/terms-of-use":
                return <TermsOfUse />;
              case "/content-policy":
                return <ContentPolicy />;
              case "/ai-policy":
                return <AiPolicy />;
              case "/publisher-terms-of-service":
                return <PublisherTerms />;
              default:
                return null;
            }
          })()}
        </Flex>
      </Flex>
    </Flex>
  );
}
